import importerSelectors from 'src/modules/shared/importer/importerSelectors';

const dataLakeImporterSelectors = importerSelectors(
  'dataLake.importer',
);

export default dataLakeImporterSelectors;
